export enum HealthProductVariance {
  ILLNESS = 'Illness Only',
  ILLNESS_ACCIDENT = 'Illness & Accident',
  ACCIDENT = 'Accident Only'
}
